import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=af745b42"
import script from "./back-to-top.vue?vue&type=script&lang=js"
export * from "./back-to-top.vue?vue&type=script&lang=js"
import style0 from "./back-to-top.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports